class LeftPick {
    constructor() {
        this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
    }
    listen(callback) {
        var that = this;
        viewer.scene.globe.depthTestAgainstTerrain = true;
        //设置鼠标移动事件的处理函数，这里负责监听x,y坐标值变化
        that.handler.setInputAction(function (movement) {
            var cartesian = viewer.scene.pickPosition(movement.position);
            if (cartesian) {
                callback(cartesian);
            }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }
    clear() {
        this.handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        //viewer.scene.globe.depthTestAgainstTerrain = false;
    }
}

export default LeftPick;